import $ from 'jquery';

export default class DynamicImagesWithText {
  constructor(instance) {
    this.$el = $(instance.el);
    this.$productDetailsSlideshow = $('.product-details-slideshow-nav-list-item', this.$el);
    this.$productDetailsSlideshow.on('click.images-with-text', (event) => {
      event.preventDefault();
      this.specificSlide(event);
    });

    this.slidePagination = $('.product-details-slideshow-nav-list', this.$el);

    this.slidePagination
      .children()
      .first()
      .addClass('active');
    this.$el
      .find('.product-details-slideshow-list-item')
      .first()
      .addClass('active');
  }

  specificSlide(event) {
    if (!$(event.currentTarget).hasClass('active')) {
      const index = $(event.currentTarget).attr('data-position');
      this.updateSlidePagination(index);
    }
  }

  updateSlidePagination(index) {
    this.$el
      .find('.product-details-slideshow-nav-list-item')
      .removeClass('active');
    this.$el
      .find(`.product-details-slideshow-nav-list-item[data-position='${index}']`)
      .addClass('active');

    this.showNewSlide(index);
  }

  showNewSlide(index) {
    this.$el
      .find(`.product-details-slideshow-list-item[data-position='${index}']`)
      .addClass('active')
      .focus()
      .siblings()
      .removeClass('active');
  }

  onSectionBlockSelect(block) {
    const index = $(block.el).index() + 1;
    this.updateSlidePagination(index);
  }

  onSectionUnload() {
    this.$productDetailsSlideshow.off('.images-with-text');
  }
}
